/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { enqueueSpotify } from './embed';
import { getSpotifyURI } from './util';
import { EmbedMedia } from './embed_media_abstract';

/*
    Spotify provides a limited API only for podcasts:
    https://developer.spotify.com/documentation/embeds/references/iframe-api/
    For other embeds we simply insert an iframe via oEmbed.

    For more control we _can_ enable the full api on that iframe,
    similar to what we do with soundcloud, but there
    is really no need for programmatic control (play/pause) right now.
    https://developer.spotify.com/documentation/web-api/
*/

export class SpotifyEmbed extends EmbedMedia {
    async load(): Promise<this> {
        if (this.url.includes('episode')) {
            this.api();
            return this;
        }

        const response = await fetch('https://open.spotify.com/oembed?url=' + this.url);
        if (!response.ok) {
            throw new Error('HTTP status: ' + response.status);
        }
        const data = await response.json();

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (data['html']) {
            const target = <HTMLElement>this.placeholder?.parentNode;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            target.innerHTML = data['html'];
        }
        return this;
    }

    play(): void {
        if (!this.player) {
            return;
        }

        if (typeof this.player.play === 'function') {
            this.player.play();
        }
    }

    pause(): void {
        // there is no real pause method in this api
    }

    api(): void {
        this.addScript('https://open.spotify.com/embed-podcast/iframe-api/v1');

        enqueueSpotify((IFrameAPI) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            IFrameAPI.createController(
                this.placeholder,
                {
                    uri: getSpotifyURI(this.url)
                },
                (EmbedController) => {
                    this.player = EmbedController;
                }
            );
        });
    }
}
